import {createContext} from "react";
import {GraphQLClient} from "./graphqlClient";

export interface GraphQLClientContextType {
    client: GraphQLClient;
}

export const GraphQLClientContext = createContext<GraphQLClientContextType>(undefined as any)


